/* SuperMythic PDP interactions: swipe gallery + full-screen viewer, size-guide sheet
   (inch/cm), size gate (no preselected size), sticky add-to-cart bar, and price-in-button
   (synced across variant changes).
   Vanilla JS; piggybacks on Dawn's product-form.js for the actual add-to-cart,
   slider-component (global.js) for the gallery counter and product-modal for the viewer. */
(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  /* A history entry per open overlay, so the phone back gesture closes the overlay instead
     of leaving the page. open() pushes once; a back gesture runs onBack; closing any other
     way calls close(), which pops the entry it pushed. */
  function historyLayer(onBack) {
    var pushed = false;
    window.addEventListener('popstate', function () {
      if (!pushed) return;
      pushed = false;
      onBack();
    });
    return {
      open: function () {
        if (pushed) return;
        history.pushState({ smOverlay: true }, '', window.location.href);
        pushed = true;
      },
      close: function () {
        if (!pushed) return;
        pushed = false;
        history.back();
      },
    };
  }

  function init(root) {
    if (root.dataset.smPdpReady) return;
    root.dataset.smPdpReady = '1';

    /* ----- Gallery (thumb click, swipe, variant-change media swap) ----- */
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sm-thumb]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('.sm-gallery__slide[data-sm-media]'));
    var track = root.querySelector('.sm-gallery__track');
    var slider = root.querySelector('.sm-gallery__slider');

    function indexOfMedia(mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-sm-media') === String(mediaId)) return i;
      }
      return -1;
    }

    // Marks the active slide and thumbnail; keeps the active thumbnail in view in the
    // mobile thumbnail row without moving the page.
    function setActive(index) {
      var slide = slides[index];
      if (!slide) return;
      var mediaId = slide.getAttribute('data-sm-media');
      slides.forEach(function (s) { s.classList.toggle('is-active', s === slide); });
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-sm-thumb') === mediaId;
        t.classList.toggle('is-active', on);
        if (on && t.parentElement && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
          var row = t.parentElement;
          if (t.offsetLeft < row.scrollLeft || t.offsetLeft + t.offsetWidth > row.scrollLeft + row.clientWidth) {
            row.scrollTo({ left: t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
          }
        }
      });
    }

    // Shows a media item: under 750px the swipe track scrolls to it (the scroll fires
    // slideChanged, which marks it active); from 750px it cross-fades in place.
    function goToMedia(mediaId) {
      if (mediaId == null) return false;
      var index = indexOfMedia(mediaId);
      if (index < 0) return false; // no matching media in this gallery; leave it untouched
      if (mobileQuery.matches && track) {
        track.scrollTo({ left: index * track.clientWidth });
      }
      setActive(index);
      return true;
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        goToMedia(btn.getAttribute('data-sm-thumb'));
      });
    });

    // Swipes and the counter arrows (Dawn's slider-component) keep the thumbnails in step.
    if (slider) {
      slider.addEventListener('slideChanged', function (event) {
        var el = event.detail && event.detail.currentElement;
        if (!mobileQuery.matches || !el) return;
        setActive(slides.indexOf(el));
      });
    }

    /* On variant change, jump the gallery to that variant's featured media — the same
       featured_media.id Dawn's product-info.js computes. We have no <media-gallery>, so we
       subscribe to Dawn's pub/sub variantChange (published after product-info resolves the
       variant) and run our own media swap. Falls back silently to thumb-only if unavailable.
       Dawn re-initialises accelerated checkout buttons with PaymentButton.init() after it
       swaps product markup; the same call here covers a variant change. */
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var variant = event && event.data && event.data.variant;
          var mediaId = variant && variant.featured_media && variant.featured_media.id;
          if (mediaId != null) goToMedia(mediaId);
          if (root.querySelector('.sm-pay-btn')) window?.Shopify?.PaymentButton?.init();
        });
      }
    } catch (e) {
      /* pub/sub not present; thumbnail clicks still swap the gallery */
    }

    /* ----- Full-screen viewer (Dawn product-modal) -----
       product-modal moves itself to <body>, so it is looked up by id. Dawn's
       showActiveMedia marks the tapped image; we then place the swipe track on it,
       keep the counter current, and add prev/next and the back gesture. */
    var viewer = document.getElementById('ProductModal-' + root.dataset.section);
    var viewerTrack = viewer && viewer.querySelector('[data-sm-viewer-track]');
    if (viewer && viewerTrack && slides.length) {
      var viewerCount = viewer.querySelector('[data-sm-viewer-count]');
      var viewerIndex = function () {
        return Math.round(viewerTrack.scrollLeft / Math.max(1, viewerTrack.clientWidth));
      };
      var paintCount = function () {
        if (viewerCount) viewerCount.textContent = viewerIndex() + 1 + ' / ' + slides.length;
      };
      var viewerHistory = historyLayer(function () {
        if (viewer.hasAttribute('open')) viewer.hide();
      });
      var openedAt = 0;
      var pageY = 0;

      viewerTrack.addEventListener('scroll', paintCount, { passive: true });
      viewer.querySelectorAll('[data-sm-viewer-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          viewerTrack.scrollBy({ left: Number(b.getAttribute('data-sm-viewer-step')) * viewerTrack.clientWidth, behavior: 'smooth' });
        });
      });

      new MutationObserver(function () {
        if (viewer.hasAttribute('open')) {
          viewerTrack.scrollTo({ left: openedAt * viewerTrack.clientWidth });
          window.scrollTo(0, pageY);
          paintCount();
          viewerHistory.open();
        } else {
          // Leave the gallery on the image the shopper last viewed.
          var last = slides[viewerIndex()];
          if (last) goToMedia(last.getAttribute('data-sm-media'));
          viewerHistory.close();
        }
      }).observe(viewer, { attributes: true, attributeFilter: ['open'] });

      slides.forEach(function (slide, i) {
        slide.addEventListener('click', function () {
          if (typeof viewer.show !== 'function') return;
          openedAt = i;
          pageY = window.scrollY;
          viewer.show(slide);
        });
      });
    }

    /* ----- Size-guide sheet ----- */
    var drawer = root.querySelector('.sm-drawer');
    if (drawer) {
      var body = drawer.querySelector('.sm-drawer__body');
      var panel = drawer.querySelector('.sm-drawer__panel');
      var opener = null;
      var sheetHistory = historyLayer(function () {
        if (!drawer.hidden) closeDrawer(true);
      });
      var openDrawer = function (event) {
        opener = event && event.currentTarget;
        drawer.hidden = false;
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
          if (panel) panel.focus({ preventScroll: true });
        });
        document.documentElement.style.overflow = 'hidden';
        sheetHistory.open();
      };
      var closeDrawer = function (fromHistory) {
        drawer.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        setTimeout(function () { drawer.hidden = true; }, 320);
        if (fromHistory !== true) sheetHistory.close();
        if (opener) opener.focus({ preventScroll: true });
      };
      root.querySelectorAll('[data-sm-sizeguide-open]').forEach(function (b) {
        b.addEventListener('click', openDrawer);
      });
      drawer.querySelectorAll('[data-sm-sizeguide-close]').forEach(function (b) {
        b.addEventListener('click', closeDrawer);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !drawer.hidden && drawer.classList.contains('is-open')) closeDrawer();
      });
      drawer.querySelectorAll('[data-sm-unit]').forEach(function (b) {
        b.addEventListener('click', function () {
          drawer.querySelectorAll('[data-sm-unit]').forEach(function (x) {
            x.classList.toggle('is-active', x === b);
          });
          if (body) body.setAttribute('data-sm-units', b.getAttribute('data-sm-unit'));
        });
      });
    }

    /* ----- Estimated delivery date -----
       Business-day windows per market country (production 2 to 5 days plus
       shipping). Computed client-side so CDN page caching never serves a stale
       date; the line ships hidden and only unhides for supported countries. */
    var delivery = root.querySelector('[data-sm-delivery]');
    if (delivery) {
      var shippingDays = { US: [5, 9], GB: [8, 16], CA: [8, 16], AU: [9, 22], NZ: [9, 22] };
      var window_ = shippingDays[(delivery.getAttribute('data-country') || '').toUpperCase()];
      var deliveryText = delivery.querySelector('[data-sm-delivery-text]');
      var template = delivery.getAttribute('data-text') || '';
      if (window_ && deliveryText && template) {
        var addBusinessDays = function (from, days) {
          var d = new Date(from.getTime());
          while (days > 0) {
            d.setDate(d.getDate() + 1);
            if (d.getDay() !== 0 && d.getDay() !== 6) days--;
          }
          return d;
        };
        try {
          var fmt = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { month: 'short', day: 'numeric' });
          var today = new Date();
          var minDate = addBusinessDays(today, 2 + window_[0]);
          var maxDate = addBusinessDays(today, 5 + window_[1]);
          deliveryText.textContent = template.replace('[min]', fmt.format(minDate)).replace('[max]', fmt.format(maxDate));
          delivery.hidden = false;
        } catch (e) {
          /* Intl unavailable; the line stays hidden */
        }
      }
    }

    /* ----- Size gate (all product pages, since 2026-10-15) -----
       No size is preselected. Until the shopper picks a size, every size option is unchecked,
       the add-to-cart button is disabled and reads "Choose your size", and the express checkout
       buttons are held back. Colour stays preselected so the gallery still follows it. Once a
       size is picked the button reads "Add to bag" (the price is appended by ensurePrice below).
       Dawn's product-info.js re-renders the option markup after every option change, with the
       server's resolved size checked, so the gate re-applies after each re-render until a size
       has been picked in this page view. Dawn's own state text (Sold out, Unavailable) is left
       alone. */
    var GATE_LABEL = 'Choose your size';
    var READY_LABEL = 'Add to bag';
    var sizeChosen = false;
    var sizeGated = !!root.querySelector('.sm-opt--size');
    function gateSubmit() {
      return root.querySelector('.product-form__submit');
    }
    function applySizeGate() {
      if (!sizeGated) return;
      var submit = gateSubmit();
      var text = submit && submit.querySelector('span');
      var pay = root.querySelector('.shopify-payment-button');
      if (!sizeChosen) {
        root.querySelectorAll('.sm-opt--size input:checked').forEach(function (i) {
          i.checked = false;
        });
        if (!root.classList.contains('sm-size-pending')) root.classList.add('sm-size-pending');
        if (pay && !pay.hasAttribute('inert')) pay.setAttribute('inert', '');
        if (submit) {
          if (!submit.hasAttribute('disabled')) submit.setAttribute('disabled', 'disabled');
          if (text && text.textContent.trim() !== GATE_LABEL) text.textContent = GATE_LABEL;
        }
        return;
      }
      if (root.classList.contains('sm-size-pending')) root.classList.remove('sm-size-pending');
      if (pay && pay.hasAttribute('inert')) pay.removeAttribute('inert');
      if (submit && text && !submit.hasAttribute('disabled')) {
        var t = text.textContent.trim();
        var dawnAdd = window.variantStrings && window.variantStrings.addToCart;
        if (t === GATE_LABEL || (dawnAdd && t === dawnAdd)) text.textContent = READY_LABEL;
      }
    }
    /* A buy button tapped before a size is picked (main button or sticky bar): bring the size
       row into view, focus the first size, and ring the size pills for a moment with Dawn's
       existing .focused fallback ring. A scripted focus after a tap shows no :focus-visible
       ring on phones, so the focus alone gives no visible cue. */
    var nudgeTimer = 0;
    function nudgeToSize() {
      var row = root.querySelector('.sm-opt--size');
      if (!row) return;
      row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var inputs = row.querySelectorAll('input:not([disabled])');
      if (inputs[0]) inputs[0].focus({ preventScroll: true });
      inputs.forEach(function (i) {
        i.classList.add('focused');
      });
      clearTimeout(nudgeTimer);
      nudgeTimer = setTimeout(function () {
        row.querySelectorAll('input.focused').forEach(function (i) {
          i.classList.remove('focused');
        });
      }, 1600);
    }
    if (sizeGated) {
      /* Capture phase, so the pick is recorded before variant-selects handles the change.
         Its handler disables the submit button, and on a real tap the MutationObserver below
         runs between listeners: a bubble-phase listener here would find the size already
         unchecked by the gate and never record it (the 2026-10-15 to 16 dead button). */
      root.addEventListener(
        'change',
        function (e) {
          var t = e.target;
          if (t && t.closest && t.closest('.sm-opt--size') && t.checked) sizeChosen = true;
        },
        true
      );
      // Enter in the quantity box, or any other path to a submit, is held until a size is picked.
      root.addEventListener(
        'submit',
        function (e) {
          if (sizeChosen) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          var first = root.querySelector('.sm-opt--size input:not([disabled])');
          if (first) first.focus();
        },
        true
      );
      /* The gated main button is disabled, and a disabled button gets no click. While pending,
         CSS gives it pointer-events: none (sections/sm-main-product.liquid), so the tap lands on
         its .product-form__buttons wrapper; a tap inside the button's box nudges to the sizes. */
      root.addEventListener('click', function (e) {
        if (!root.classList.contains('sm-size-pending')) return;
        if (!e.target.closest || !e.target.closest('.product-form__buttons')) return;
        var submit = gateSubmit();
        if (!submit) return;
        var r = submit.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) return;
        nudgeToSize();
      });
      applySizeGate();
      new MutationObserver(applySizeGate).observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled'],
      });
      // Back/forward cache restores the old DOM; a size picked before leaving still counts.
      window.addEventListener('pageshow', function () {
        sizeChosen = !!root.querySelector('.sm-opt--size input:checked') && sizeChosen;
        applySizeGate();
      });
    }

    /* ----- Price in the add-to-cart button (survives variant re-renders) ----- */
    var info = root.querySelector('.sm-pdp__info-inner');
    function ensurePrice() {
      var submit = root.querySelector('.product-form__submit');
      var priceItem = root.querySelector('.sm-pdp__price .price-item--sale:not([hidden]), .sm-pdp__price .price-item--regular');
      if (!submit || !priceItem || submit.hasAttribute('disabled')) {
        if (submit) {
          var stale = submit.querySelector('.sm-atc-price');
          if (stale) stale.remove();
        }
        return;
      }
      var want = '· ' + priceItem.textContent.trim();
      var span = submit.querySelector('.sm-atc-price');
      if (!span) {
        span = document.createElement('span');
        span.className = 'sm-atc-price';
        span.textContent = want;
        submit.appendChild(span);
      } else if (span.textContent !== want) {
        span.textContent = want;
      }
    }
    if (info) {
      ensurePrice();
      new MutationObserver(ensurePrice).observe(info, { childList: true, subtree: true, characterData: true });
    }

    /* ----- Sticky add-to-cart bar (mobile + desktop) ----- */
    var sticky = root.querySelector('[data-sm-sticky]');
    var mainSubmit = root.querySelector('.product-form__submit');
    if (sticky && mainSubmit && 'IntersectionObserver' in window) {
      var stickyBtn = sticky.querySelector('[data-sm-sticky-add]');
      var stickyLabel = sticky.querySelector('[data-sm-sticky-label]');
      var stickyPrice = sticky.querySelector('[data-sm-sticky-price]');
      var stickyVariant = sticky.querySelector('[data-sm-sticky-variant]');
      var submitInView = true;

      /* Dawn's drawers/modals (cart drawer, menu drawer, media modal) lock scroll with
         body.overflow-hidden; our size-guide drawer locks html overflow. Either means an
         overlay is up, so the bar stays out of the way. */
      var overlayOpen = function () {
        return (
          document.body.classList.contains('overflow-hidden') ||
          document.documentElement.style.overflow === 'hidden'
        );
      };

      var updateVisibility = function () {
        var visible = !submitInView && !overlayOpen();
        sticky.classList.toggle('is-visible', visible);
        /* Body-level state so global CSS can move app chrome (Shopify Inbox
           launcher) clear of the bar; the var carries the bar's real height. */
        if (visible) document.body.style.setProperty('--sm-sticky-atc-h', sticky.offsetHeight + 'px');
        document.body.classList.toggle('sm-sticky-atc-open', visible);
      };

      /* Mirror the main button: product-info.js owns its disabled state and state text
         (Add to cart / Sold out / Unavailable), so the bar never re-derives variant logic. */
      var syncStickyState = function () {
        var stateText = mainSubmit.querySelector('span');
        if (stickyLabel && stateText) {
          var want = stateText.textContent.trim();
          if (want && stickyLabel.textContent !== want) stickyLabel.textContent = want;
        }
        if (stickyBtn) {
          // Size not picked yet: the bar stays live and scrolls to the size row (see click below).
          stickyBtn.disabled = root.classList.contains('sm-size-pending')
            ? false
            : mainSubmit.hasAttribute('disabled') || mainSubmit.getAttribute('aria-disabled') === 'true';
        }
        var p = root.querySelector('.sm-pdp__price .price-item--sale:not([hidden]), .sm-pdp__price .price-item--regular');
        if (stickyPrice && p) stickyPrice.textContent = p.textContent.trim();
      };

      /* Watch the whole buy block (Add to cart plus the dynamic checkout button under it),
         so the bar only shows once both are off screen and never covers either. */
      var buyBlock = mainSubmit.closest('.product-form__buttons') || mainSubmit;
      var io = new IntersectionObserver(function (entries) {
        submitInView = entries[0].isIntersecting;
        updateVisibility();
      }, { threshold: 0 });
      io.observe(buyBlock);

      new MutationObserver(updateVisibility).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      new MutationObserver(updateVisibility).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
      new MutationObserver(syncStickyState).observe(mainSubmit, { attributes: true, childList: true, subtree: true, characterData: true });
      new MutationObserver(syncStickyState).observe(root, { attributes: true, attributeFilter: ['class'] });
      if (info) new MutationObserver(syncStickyState).observe(info, { childList: true, subtree: true, characterData: true });

      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
            var variant = event && event.data && event.data.variant;
            if (stickyVariant) stickyVariant.textContent = variant && variant.title ? variant.title : '';
            syncStickyState();
          });
        }
      } catch (e) {
        /* pub/sub not present; MutationObservers still keep the bar in sync */
      }

      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (root.classList.contains('sm-size-pending')) {
            nudgeToSize();
            return;
          }
          mainSubmit.click();
        });
      }

      syncStickyState();
    }
  }

  function boot() {
    document.querySelectorAll('.sm-pdp').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
